import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, useApolloClient as useAppApolloClient } from '@apollo/client';
import { HEADER_DATA_SOURCE } from '../externals';

var useApolloClient = function useApolloClient(_ref) {
  var headerDataSource = _ref.headerDataSource;

  try {
    /** If an ApolloProvider is found up in the application tree, then try block will be executed with a new HttpLink being added in the ApolloLink tree
     *  at [HEADER_DATA_SOURCE] context
     */
    var apolloClient = useAppApolloClient();
    apolloClient.setLink(ApolloLink.split(
    /* istanbul ignore next */
    function (op) {
      var context = op.getContext();
      return !!context[HEADER_DATA_SOURCE];
    }, new HttpLink({
      uri: headerDataSource,
      credentials: 'include',
      fetchOptions: {
        credentials: 'include'
      }
    }), apolloClient.link));
    return {
      client: apolloClient,
      existingClient: true
    };
  } catch (e) {
    /**
     * If an ApolloProvider is not found up in the application tree, then catch block will be executed with a new ApolloClient being created and returned
     */
    return {
      client: new ApolloClient({
        link: new HttpLink({
          uri: headerDataSource,
          credentials: 'include',
          fetchOptions: {
            credentials: 'include'
          }
        }),
        cache: new InMemoryCache(),
        ssrMode: typeof window === 'undefined'
      }),
      existingClient: false
    };
  }
};

export default useApolloClient;